export default {
    methods: {
        getEditLink(product, disabledLink = false) {
            if (!product.productable_type || disabledLink) return "javascript:void(0)"
            switch (product.productable_type || product.fileable_type) {
                case "course":
                case "marathon":
                    return `/expert/product/detail/${product.productable_id || product.fileable.id}/program`
                // case "marafon":
                //     return `/expert/product/detail/${product.productable_id}/settings/edit`
                case "webinar":
                case "auto-webinar":
                    return `/expert/webinar/${product.productable_id}/edit`
                case "consult":
                    return `#`
                case "closed_group":
                    return `/expert/closed-group/detail/${product.productable_id}/settings/edit`
                case "quiz":
                    return `/expert/quiz/${product.productable_id}/constructor`
                case "call_action":
                    return `/expert/cta/${product.id}`
                case "guide":
                    return `#`
                case "custom_product":
                    return `#`
                default:
                    return `/expert/product/detail/${product.productable_id}/settings/edit`
            }
        },
        getManagementLink(product, disabledLink = false) {
            if (!product.productable_type || disabledLink) return "javascript:void(0)"
            switch (product.productable_type || product.fileable_type) {
                case "course":
                case "marathon":
                    return `/expert/product/detail/${product.productable_id || product.fileable.id}/management`
                case "webinar":
                case "auto-webinar":
                    return `/expert/webinar/${product.productable_id}/edit/admins`
                case "consult":
                    return `#`
                case "closed_group":
                    return `/expert/closed-group/detail/${product.productable_id}/access`
                case "custom_product":
                    return `#`
                default:
                    return `/expert/product/detail/${product.productable_id}/management`
            }
        }
    }
}
